export default function CertificateIcon({ size = 18, color = "black" }) {
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="30"
      height="30"
      viewBox="0 0 45 45"
    >
      <g>
        <path
          stroke="#fff"
          fill="white"
          strokeWidth="0px"
          d="M34.8,29.7c-2.4,0-4.8-1-6.5-2.7-1.7-1.7-2.7-4.1-2.7-6.5s1-4.8,2.7-6.5c1.7-1.7,4.1-2.7,6.5-2.7s4.8,1,6.5,2.7c1.7,1.7,2.7,4.1,2.7,6.5,0,2.4-1,4.8-2.7,6.5s-4.1,2.7-6.5,2.7h0ZM34.8,13.3c-2.9,0-5.5,1.7-6.6,4.4-1.1,2.7-.5,5.8,1.6,7.8,2,2,5.1,2.7,7.8,1.6,2.7-1.1,4.4-3.7,4.4-6.6,0-4-3.2-7.2-7.2-7.2h0Z"
        />
        <path
          stroke="white"
          fill="white"
          strokeWidth="0px"
          d="M40.9,42c-.1,0-.2,0-.3,0l-5.8-1.9-5.8,1.9c-.3.1-.7,0-.9-.1-.3-.2-.4-.5-.4-.8v-15.4h2v13.9l4.8-1.6c.2,0,.4,0,.6,0l4.8,1.6v-13.9h2v15.4c0,.3-.1.5-.3.7s-.5.3-.7.3h0Z"
        />
        <path
          stroke="white"
          fill="white"
          strokeWidth="0px"
          d="M23.5,35.8H2c-.6,0-1-.5-1-1V4.1c0-.6.5-1,1-1h36.9c.3,0,.5.1.7.3s.3.5.3.7v5.1h-2v-4.1H3v28.7h20.5v2Z"
        />
      </g>
      <polygon
        fillRule="evenodd"
        stroke="white"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        points="22.1 15.6 22.1 20.3 16.5 20.3 16.5 25.9 11.7 25.9 11.7 20.3 6.1 20.3 6.1 15.6 11.7 15.6 11.7 10 16.5 10 16.5 15.6 22.1 15.6"
      />
    </svg>
  );
}
